import {defineRule} from "vee-validate";

// Alla giltiga tecken från: http://bolex.intern.bolagsverket.se/bolex/arendetyper/firma/namnkonstruktion.html
export const giltiga_tecken_regexp = /[ !"%&'()+,\-./0-9:;=?A-Za-zŠšŽžŒœŸÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÑÒÓÔÕÖØÙÚÛÜÝàáâãäåæçèéêëìíîïñòóôõöøùúûüýÿ]/g;
export const svenskt_lagenhetsnummer = /^[0-9]{4}$/;
export const svenskt_postnummer = /^\d{3} ?\d{2}$/;
export const numeric = /^([0-9]+)$/;

defineRule('giltiga_tecken', (value, _, ctx) => {
  const tecken = String(value);
        let ogiltiga_tecken = tecken.replaceAll(giltiga_tecken_regexp, '');
        if(ogiltiga_tecken.length === 0)  {
            return true;
        }
        ogiltiga_tecken = [...new Set(ogiltiga_tecken)].sort();
        const antal = ogiltiga_tecken.length;
        const message_tecken = ogiltiga_tecken.join(' ');
        return `Fyll i ${ctx.field} som inte innehåller ${antal == 1 ? 'tecknet' : 'tecknen'} ${message_tecken}.`;
});

defineRule('required', (value, _, ctx) => {
    if (!value || !value.length) {
      if(ctx.field == "ett land"){
        return `Land måste väljas`
      }
      else{

      return `${ctx.field == "en postort" ? 'Postort' : ctx.field} måste anges.`;
      }
    }
    return true;
  });

defineRule('numeric', (value, _, ctx) => { 
  if (value && !numeric.test(value)) {
      return `Ogiltigt format på ${ctx.field}.`;
    }
    return true;
  });

defineRule('svensktlagenhetsnr', value => {
    if (value && !svenskt_lagenhetsnummer.test(value)){
        return 'Ogiltigt format på lägenhetsnummer.'
    }
    return true;
});
defineRule('ej_vaningsplan_med_lagenhetsnummer', (value, [target]) => {
    if(value && target){
        return 'Ta bort våningsplan. Våningsplanet ingår i lägenhetsnumret.'
    }
    return true;
});
defineRule('svenskt_postnummer', value =>{
    if(value && !svenskt_postnummer.test(value)){
        return 'Ogiltigt format på postnummer.'
    }
    return true;
})
defineRule('kant_postnummer', (_, [target]) =>{
    if(target === 'Okänt postnummer'){
        return 'Vi kunde inte hämta några uppgifter. Kontrollera postnumret.'
    }
    return true;
})
for(let i of [1,2,3,4,5]) {
defineRule(`required_if_${i}`, (value, [target, target_name], ctx) => {
  if (!value && target) {
    return `Eftersom du har fyllt i ${target_name} måste du fylla i ${ctx.field}`;
  }
  return true;
});
}
